import classNames from "classnames";
import { useCheckIsAdmin } from "utils";

const MenuGroupHeader = ({
  name,
  hideForNoAdmins = false,
}: {
  name: string;
  hideForNoAdmins?: boolean;
}) => {
  const isAdmin = useCheckIsAdmin();
  return (
    <div
      className={classNames(
        "bg-primary text-[12px] text-[#80B1CE] font-medium pt-6 pb-1 pl-6",
        {
          hidden: hideForNoAdmins && !isAdmin,
        }
      )}
    >
      {name}
    </div>
  );
};

export default MenuGroupHeader;
